import type { FilterState as ControllerFilterState } from '@atlassian/filter-controller';
import type { SingleOption } from '@atlassian/paginated-filter';

export const toSingleOptions = (
  options: ControllerFilterState['filters'][string],
): readonly SingleOption[] => {
  if (!Array.isArray(options)) {
    throw new TypeError('Expected paginated filter value to be an array');
  }

  return options;
};
